import { render, staticRenderFns } from "./CampersList.vue?vue&type=template&id=2bcd3718&scoped=true&"
import script from "./CampersList.vue?vue&type=script&lang=js&"
export * from "./CampersList.vue?vue&type=script&lang=js&"
import style0 from "./CampersList.vue?vue&type=style&index=0&id=2bcd3718&lang=scss&scoped=true&"
import style1 from "./CampersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd3718",
  null
  
)

export default component.exports